module.exports = __webpack_public_path__ + "img/compact.24b6184d.png";